// extracted by mini-css-extract-plugin
export default {"wrapper":"FV-z","availablePromoMessagesLabel":"GV-z","promoMessageList":"HV-z","promoMessage":"IV-z","appliedPromoMessage":"JV-z","promoMessageAmount":"KV-z"};